<template>
    <div>
        
        <div class="brand-opt">
            <el-button @click="handleAddCategoryOtherSet">新增</el-button>
            <el-button type='primary' @click="handleBatchDelete">批量删除</el-button>
        </div>
        <div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item>
                    <el-select 
                        v-model="formInline.shopId"
                        placeholder="请选择店铺" 
                        clearable
                        filterable
                        remote
                        width="200px"
                        >
                        <el-option
                            v-for="shopItem in shopList"
                            :key="shopItem.id"
                            :label="shopItem.shortTitle || shopItem.title"
                            style="width: 150px;"
                            :title="shopItem.shortTitle || shopItem.title"
                            :value="shopItem.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input clearable v-model="formInline.brand" placeholder="品牌"></el-input>
                </el-form-item>
                <el-form-item>
                     <el-input clearable v-model="formInline.categoryName" placeholder="输入关键词查询类目"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin:16px 0">
            <el-table 
                ref="tableRef" 
                :data="tableData" 
                row-key="distributorCompanyId" 
                width="400px" 
                height="350px" 
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column prop="shopId" label="适配店铺">
                    <template slot-scope="{ row }">
                        <el-image :src="PLATFORMS_ICONS[platform]" fit="fill" class="shop-img"></el-image>
                        {{ getShopTitle(row.parent.shopId) }}
                    </template>
                </el-table-column>
                <el-table-column prop="relations" label="适用类目">
                    <template slot-scope="{ row }">
                       {{row.parentCategoryNames && row.parentCategoryNames.length ?row.parentCategoryNames.join(','):''}}
                    </template>
                </el-table-column>
                <el-table-column prop="distributorCompanyName" label="品牌">
                    <template slot-scope="{ row }">
                        {{row.vvalue}} <span style="color: #f00" v-if="row.status === 0">(品牌授权失效)</span>
                    </template>
                </el-table-column>
                <el-table-column prop="distributorLevel" label="操作">
                    <template slot-scope="{row}">
                        <el-button @click="handleEdit(row)">编辑</el-button>
                        <el-button @click="handleDelete(row)" type='primary'>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <AddCategoryOtherDialog :brandData="tableData" :shopList="shopList" :platform="platform" ref="categoryOtherDialogRef" @update-relations="handleUpdateRelations"/>
        </div>
    </div>
</template>
<script>
import AddCategoryOtherDialog from "@components/prod/center/dialogs/AddCategoryOtherDialog.vue";
import { PLATFORMS_ICONS } from '@/dictionary/platforms';
import { cloneDeep } from 'lodash';

export default {
    model: {
        prop: 'value',
        event: 'input'
    },
    props:{
        value:{
            type:Array,
            default:[]
        },
        shopList:{
            type:Array,
            default:[]
        },
    },
    inject:['platform'],
    components:{
        AddCategoryOtherDialog,
    },
    watch:{
        value:{
            handler(v){
                if(v){
                    this.tableData = v
                } else {
                    this.tableData = []
                }
            },
            immediate:true,
        }
    },
    data(){
        return {
            formInline:{},
            tableData:[],
            multipleSelection:[],
            PLATFORMS_ICONS,
        }
    },
    methods:{
        getShopTitle(shopId){
            const shop = this.shopList.find(item => item.id == shopId)
            return shop ? (shop.shortTitle || shop.title) : ''
        },
        handleAddCategoryOtherSet(){
            this.$refs.categoryOtherDialogRef.method_open({
                visibleType:'ADD'
            },()=>{

            })
        },
        handleEdit(row){
            this.$refs.categoryOtherDialogRef.method_open({
                visibleType:'EDIT',
                categoryRow: row
            },()=>{

            })
        },
        handleUpdateRelations({ payload, payloadType }){
            const current = Array.isArray(this.value) ? this.value.slice() : []
            const shopId = payload.shopId
            if(payloadType === 'EDIT'){
                const edited = payload.relations[0]
                const idx = current.findIndex(r => r.parent && r.parent.shopId == shopId && r.categoryId == edited.previewCategoryId)
                const newRow = { ...edited, previewCategoryId: edited.categoryId, parent: (idx !== -1 && current[idx] && current[idx].parent) ? current[idx].parent : { shopId } }
                if(idx !== -1){
                    current.splice(idx,1,newRow)
                } else {
                    current.push(newRow)
                }
            } else {
                payload.relations.forEach(rel => {
                    current.push({ ...rel, previewCategoryId: rel.categoryId, parent: { shopId } })
                })
            }
            this.$emit('input', current)
        },
        handleDelete(row){
            var that = this;
            this.$confirm('确认要删除选中的品牌配置吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const next = (this.value || []).filter(item => !(item.parent && item.parent.shopId == row.parent.shopId && item.categoryId == row.categoryId))
                this.$emit('input', next)
                this.$message({ message: '删除成功', duration: 2000, type: 'success' });
            }).catch(() => {
            //点取消的提示
                return;
            });
        },
        handleBatchDelete(){
            if(!this.multipleSelection.length){
               return this.$message({ message: '请选择要删除的数据', duration: 2000, type: 'success' });
            }
            var that = this;
            this.$confirm('确认要删除选中的品牌配置吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const toDelete = this.multipleSelection
                const next = (this.value || []).filter(item => !toDelete.some(row => row.parent && item.parent && item.parent.shopId == row.parent.shopId && item.categoryId == row.categoryId))
                this.$emit('input', next)
                this.$message({ message: '删除成功', duration: 2000, type: 'success' });
            }).catch(() => {
            //点取消的提示
                return;
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        filteredData(searchParams){
            const {shopId,brand,categoryName} = searchParams
            let data = Object.assign([],this.value)
            return data.filter(item => {
                // 检查每个条件是否存在，并构建过滤逻辑
                const categoryNameMatch = categoryName ? 
                    item.parentCategoryNames.some(name => name.toLowerCase().includes(categoryName.toLowerCase())) : true;
                const shopIdMatch = shopId ? 
                    item.parent.shopId === shopId : true;
                const vvalueMatch = brand ? 
                    item.vvalue.toLowerCase().includes(brand.toLowerCase()) : true;

                // 只要满足其中一个条件即可
                return categoryNameMatch && shopIdMatch && vvalueMatch;
            })
        },
        onSubmit() {
            const searchParams = this.formInline
            const res = this.filteredData(searchParams)
            this.tableData = res
        },
    }
    
}
</script>
<style lang="scss" scoped>
.brand-opt{
    margin: 8px 0px;
}

.shop-img {
    // width: 16px;
    height: 16px;
    // border-radius: 50%;
    vertical-align: middle;
}
</style>